// SPEC F3 — işe alım maliyeti için SAF yardımcılar (çekmece, rapor ve pano
// aynı kaynaktan okur; iki dosyada ayrı kopya bir yeniden adlandırmada
// sessizce ayrışırdı).

// Backend AtsRecruitingCost.Category kümesi — birebir.
export const RECRUITING_COST_CATEGORIES = [
  'job_board', 'agency', 'referral_bonus', 'advertising',
  'assessment', 'travel', 'relocation', 'other',
];

// AtsSettings.RecruitingCostCurrency kümesi (varsayılan TRY). Döviz çevrimi
// YOK: kayıt yalnız ayardaki para biriminde girilir.
export const RECRUITING_COST_CURRENCIES = ['TRY', 'USD', 'EUR', 'GBP'];
export const DEFAULT_RECRUITING_COST_CURRENCY = 'TRY';

export const EMPTY = '—';

const isBlank = (v) => v === null || v === undefined || v === '';

// Para biçimi — Intl para birimi stili, dil duyarlı. null/boş → "—" (0 DEĞİL:
// "işe alım yok" ile "maliyet sıfır" farklı şeylerdir).
export function formatMoney(value, currency, lang = 'tr') {
  if (isBlank(value) || !Number.isFinite(Number(value))) return EMPTY;
  const cur = currency || DEFAULT_RECRUITING_COST_CURRENCY;
  try {
    return new Intl.NumberFormat(lang || 'tr', {
      style: 'currency', currency: cur, maximumFractionDigits: 2,
    }).format(Number(value));
  } catch {
    return `${Number(value).toLocaleString(lang || 'tr', { maximumFractionDigits: 2 })} ${cur}`;
  }
}

// Oran (0-1 kesir) → "%12,5". Payda 0 → backend null döner → "—".
export function formatRate(rate, lang = 'tr') {
  if (isBlank(rate) || !Number.isFinite(Number(rate))) return EMPTY;
  return `%${(Number(rate) * 100).toLocaleString(lang || 'tr', { maximumFractionDigits: 1 })}`;
}

// GET .../costs yanıtı: ya düz dizi ya da özet taşıyan nesne
// `{ items|costs, currency, totalCost, hiredCount, costPerHire, otherCurrencyCount }`.
// Özet alanları yoksa İSTEMCİ hesaplar — yalnız GEÇERLİ para birimindeki kayıtlar
// toplanır (karışık para toplamı yalanı yok), diğerleri sayılır.
export function summarizeCosts(payload, { currency, hiredCount } = {}) {
  const obj = payload && !Array.isArray(payload) ? payload : null;
  const items = Array.isArray(payload) ? payload : (obj?.items || obj?.costs || obj?.data || []);
  const cur = obj?.currency || currency || DEFAULT_RECRUITING_COST_CURRENCY;

  const inCur = items.filter((c) => !c.currency || c.currency === cur);
  const computedTotal = inCur.reduce((s, c) => s + (Number(c.amount) || 0), 0);
  const totalCost = !isBlank(obj?.totalCost) ? Number(obj.totalCost) : computedTotal;
  const otherCurrencyCount = !isBlank(obj?.otherCurrencyCount)
    ? Number(obj.otherCurrencyCount)
    : items.length - inCur.length;

  const hires = !isBlank(obj?.hiredCount) ? Number(obj.hiredCount)
    : (isBlank(hiredCount) ? null : Number(hiredCount));
  let costPerHire;
  if (obj && Object.prototype.hasOwnProperty.call(obj, 'costPerHire')) {
    costPerHire = isBlank(obj.costPerHire) ? null : Number(obj.costPerHire);
  } else {
    costPerHire = hires && hires > 0 ? totalCost / hires : null;
  }

  return {
    items, currency: cur, totalCost, otherCurrencyCount, hiredCount: hires, costPerHire,
  };
}
